<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconPhoneTalk_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="M11.284 4.835a.548.548 0 0 1 .425-.649c2.22-.46 4.54.168 6.207 1.69a7.085 7.085 0 0 1 2.248 6.026.548.548 0 1 1-1.09-.125 5.98 5.98 0 0 0-1.898-5.09 5.982 5.982 0 0 0-5.243-1.427.548.548 0 0 1-.649-.425ZM17.822 18.418c-.463.823-1.363 1.398-2.408 1.543-2.011.28-4.594-.954-7.508-3.867-3.562-3.56-4.07-6.047-3.868-7.507.144-1.045.72-1.945 1.543-2.408a1.37 1.37 0 0 1 1.856.492l1.566 2.61a1.376 1.376 0 0 1-.207 1.684l-.734.755c.543.882 1.16 1.63 1.874 2.343a15.257 15.257 0 0 0 2.286 1.887l.817-.752a1.37 1.37 0 0 1 1.68-.204l2.61 1.566c.643.388.86 1.203.493 1.858Z"
    />
    <path
        fill="currentColor"
        d="M11.605 7.354a.55.55 0 1 0 .42 1.014 2.968 2.968 0 0 1 3.125.538 2.968 2.968 0 0 1 .82 3.063.55.55 0 0 0 1.05.326 4.068 4.068 0 0 0-1.13-4.2 4.069 4.069 0 0 0-4.285-.741Z"
    />
</svg>
